import { v4 as uuidv4 } from 'uuid';
import { TranscoderAudioProfile, ETranscoderProfileType, TranscoderVideoProfile, TranscoderTemplate } from '.';
import { TranscoderProfile } from './util';

export const addTranscoderProfileTypeShared = <T extends TranscoderAudioProfile | TranscoderVideoProfile>(
  profile: T,
) => ({
  ...profile,
  type: ETranscoderProfileType.shared,
});

export const cleanIdFromTranscoderProfile = (profile: TranscoderProfile) => {
  if (profile.type === ETranscoderProfileType.new || profile.type === ETranscoderProfileType.cloned) {
    return { ...profile, id: undefined };
  }

  return profile;
};

export const templateInitialValues = {
  id: uuidv4(),
  name: 'Init template',
  videoProfiles: [
    {
      name: 'VIDEO PROFILE',
      codec: 'h264_gpu',
      width: 1920,
      height: 1080,
      bitrate: 6000000,
      level: '4.1',
      profile: 'main',
      resolution: '1920x1080',
      type: 'default',
      // set default fps until it will be avaialable in backend
      fps: '25',
    } as TranscoderVideoProfile,
  ],
  audioProfiles: [
    {
      language: 'pol',
      codec: 'aac',
      name: 'AUDIO PROFILE',
      bitrate: 256000,
      sampleRate: 48000,
      numberOfChannels: 6,
      type: 'default',
    } as TranscoderAudioProfile,
  ],
} as TranscoderTemplate;
